import React, { useEffect, useState } from 'react';
import './Brochure.css';
import logo from './img/logo1.png';

// 2026 한국건설·안전박람회(10.14~10.16, 킨텍스 제1전시장 리모 부스 F065) 현장에서
// QR로 여는 브로슈어 페이지. 인쇄본 8P를 모바일 요약 + 원본 페이지 이미지 + PDF 다운로드로 제공한다.
// 이 파일은 다른 랜딩 컴포넌트에 의존하지 않도록 자체 헤더/푸터/스타일을 가진다.

export const BROCHURE_PDF_URL = '/files/hongtong-brochure-2026.pdf';
export const BROCHURE_PDF_FILE_NAME = '현장통_브로슈어_2026.pdf';
const PAGE_IMAGE_BASE = '/files/brochure/p';
const EXPO = '2026 한국건설·안전박람회 · 10.14(수)~10.16(금)';

const PAGE_TITLES = [
  '표지 – 현장 안전관리자들의 동반자, 쉽고 간편한 안전관리시스템 현장통',
  '중대재해 발생 시 안전·보건 확보의무 입증',
  '현장 상황에 맞게 골라 쓰는 기능 8가지',
  '연결된 시스템 · 다국어 서비스 · 본사 모니터링',
  '주요 기능 01 위험성 평가 · 02 TBM',
  '주요 기능 03 안전 교육 · 04 종사자 의견 청취',
  '주요 기능 05 위급 사이렌 · 06 출퇴근 관리',
  '기대 효과 · 고객사 · 연락처',
];

const PROOF_ITEMS = [
  ['TBM', '매일 근로자 작업 전 실시 (TBM 사진 / 근로자 전자서명)'],
  ['위험성 평가', '근로자 작업 전 확인 (근로자 전자서명)'],
  ['안전 교육', '근로자 안전교육 실시 (안전교육 사진 / 근로자 전자서명)'],
  ['본사 시스템', '현장별 안전교육 및 위험성평가 실시 사항 확인'],
  ['위급 사이렌', '위급 시 대피 시스템 구축'],
  ['종사자 의견 청취', '종사자 의견청취 시스템 구축'],
];

const PICK_FEATURES = [
  { name: 'AI 위험성평가', soon: true, items: ['공종·작업 내용만 입력하면 AI가 초안 작성', '유해·위험요인과 감소 대책 자동 제안', '안전관리자 검토·수정 후 바로 결재'] },
  { name: 'AI 안전교육자료', soon: true, items: ['당일 작업·위험요인에 맞춘 교육자료 자동 생성', '외국인 근로자를 위한 13개 언어 번역', 'TBM·안전교육에 바로 활용'] },
  { name: '위험성평가 회의록', items: ['회의 자료·사진 첨부로 PC에서 빠르게 등록', '참석 근로자 확인 서명 · 근로자 대표 결재 지정', '자동으로 회의록 생성 · 출력'] },
  { name: '안전 점검문서', items: ['점검표·순회점검일지·주간점검표를 PC에서 빠르게 작성', '쓰던 점검 양식 그대로 등록, 날짜·현장 정보 자동 입력', '위험요인 사진 등록, 자동으로 점검 문서 생성 · 출력'] },
  { name: '작업계획서', items: ['협력사 관리자도 쉽게 PC에서 작성', '시공사 관리자 전자서명 처리 (빠른 결재 과정)', '자동으로 작업계획서 생성 · 출력'] },
  { name: '작업허가서', soon: true, items: ['협력사 관리자도 쉽게 PC에서 작성', '시공사 관리자 전자서명 처리 (빠른 결재 과정)', '자동으로 작업허가서 생성 · 출력'] },
  { name: '근로자 건강관리', soon: true, items: ['보건관리자가 쉽게 근로자 건강관리', '기저질환자, 65세 이상 고령 근로자 특별 관리', 'OCR 활용 건강 서류 관리'] },
  { name: '무사고퇴근', items: ['근로자 퇴근 시 모바일로 무사고 확인 서명', '사고 발생 시 즉시 신고, 관리자 실시간 확인', '현장별 무사고를 본사 시스템 자동 집계'] },
];

const SYSTEM_LAYERS = [
  ['본사 시스템', ['본사에서 실시간으로 모든 현장 안전 관리 모니터링', '현장 작성 모든 파일 저장 및 출력']],
  ['현장통 앱 / PC 버전', ['시공사 관리자: 앱/PC로 현장 안전 관리 및 서류 작성', '협력사 관리자: 앱/PC로 현장 안전 관리 및 서류 작성']],
  ['근로자 앱', ['위험성 평가, 안전 교육, TBM 참여 및 전자 서명', '신규채용자 서류, 지정서 등 참여 및 전자 서명']],
];

const LANGUAGES = ['한국어', '중국어', '영어', '우즈베크어', '태국어', '필리핀어', '베트남어', '러시아어', '인도네시아어', '라오스어', '힌디어', '버마어', '몽골어'];

const MAIN_FEATURES = [
  { no: '01', name: '위험성 평가', lead: '4가지 위험성평가 시스템 — 최초 · 정기 · 수시 · 상시', items: ['25,000개 데이터 적용으로 협력사도 쉽게 작성 (위험요인 / 개선대책 자동 생성)', '근로자 매일 작업 전 모바일로 위험요인 확인 유도', '작업 중 모바일로 조치 결과 쉽게 등록'] },
  { no: '02', name: 'TBM', items: ['모바일로 30초 만에 TBM 작성', '협력사 관리자도 쉽게 작성 가능', '간편한 QR 근로자 전자 서명', '자동으로 TBM 일지 생성 · 출력'] },
  { no: '03', name: '안전 교육', lead: '신규채용 · 작업변경 · 보충교육 · 특별교육 · 정기교육 · 관리감독자교육', items: ['안전관리자 업무 시간 절약', '간편한 QR 근로자 전자 서명', '특별 교육 항목 40개 자동 생성', '자동으로 교육 일지 생성 · 출력'] },
  { no: '04', name: '종사자 의견 청취', lead: "작업 중 '위험요인' 발생 시 처리 요청 / 위험성평가 근로자 의견에 반영", flow: ['근로자·관리자 위험요인 신고', "'시공사 관리자'에 신고 알림", '위험요인 처리 후 내용 작성', "'신고자'에 처리 알림"] },
  { no: '05', name: '위급 사이렌', lead: '작업 중 화재 등 위급상황 발생 시 모든 근로자·관리자 사이렌 발동 → 인명피해 감소', flow: ['화재 등 위급사항 발생', '사이렌 발동 (출근한 모든 근로자)', '대피 상황 (대피자 / 미대피자) 확인', '미대피자 위치 확인'] },
  { no: '06', name: '출퇴근 관리', items: ['안전관리의 시작은 근로자 출퇴근에서부터 시작', '전체 / 업체별 일출력 · 월출력 명부 출력 가능'] },
];

const EFFECTS = [
  ['건설 본사', ['모든 현장 실시간 모니터링', '안전보건관리체계 구축', '중대재해 발생 시 조치의무사항 입증 가능']],
  ['안전 관리자', ['효율적 안전관리', '안전관리자 업무 시간 단축', '작업 근로자 효율적 관리']],
  ['근로자', ['쉽고 빠른 출퇴근', '간편한 근무 이력 관리', '사고 위험률 감소']],
];

const CONTACTS = [
  { name: '손영훈', role: '마케팅부장', phone: '010-3789-4801', email: 'imtough2@nate.com' },
];

function track(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, { page: '/brochure', ...params });
}

function PdfLink({ className, location, children }) {
  return (
    <a className={className} href={BROCHURE_PDF_URL} download={BROCHURE_PDF_FILE_NAME} onClick={() => track('brochure_pdf_download', { location })}>
      {children}
    </a>
  );
}

// 페이지 이미지. 전시장처럼 통신이 불안정한 곳에서 WebP 로딩이 실패하면 JPEG로 대체하고,
// 그래도 실패하면 캐시를 우회해 한 번 더 받는다. 최종 실패 시 다시 불러오기 버튼을 보여준다.
function PageImage({ n, title }) {
  const [stage, setStage] = useState(0); // 0: webp(+jpg 대체) → 1: jpg → 2: jpg 재시도 → 3: 실패
  const alt = `${n}페이지 – ${title}`;
  const common = { width: 1275, height: 1790, loading: n <= 2 ? 'eager' : 'lazy', decoding: 'async' };
  const onError = () => { setStage(prev => Math.min(prev + 1, 3)); track('brochure_page_image_error', { page_no: n, stage }); };

  if (stage === 3) {
    return (
      <div className="bro-page-fallback" role="img" aria-label={alt}>
        <p>{n}페이지 이미지를 불러오지 못했습니다.<br />통신 상태를 확인한 뒤 다시 시도해 주세요.</p>
        <button type="button" className="bro-btn" onClick={() => setStage(1)}>다시 불러오기</button>
        <PdfLink className="bro-btn bro-btn-primary" location={`page${n}_fallback`}>PDF로 보기 <span aria-hidden="true">↓</span></PdfLink>
      </div>
    );
  }
  if (stage > 0) {
    const bust = stage === 2 ? `?retry=${Date.now()}` : '';
    return <img key={`jpg-${stage}`} src={`${PAGE_IMAGE_BASE}${n}.jpg${bust}`} alt={alt} onError={onError} {...common} />;
  }
  return (
    <picture>
      <source srcSet={`${PAGE_IMAGE_BASE}${n}.webp`} type="image/webp" />
      <img src={`${PAGE_IMAGE_BASE}${n}.jpg`} alt={alt} onError={onError} {...common} />
    </picture>
  );
}

function Pages() {
  return (
    <section className="bro-section" aria-labelledby="bro-pages-title">
      <h2 id="bro-pages-title" className="bro-h2">브로슈어 원본 8페이지</h2>
      <p className="bro-note">두 손가락으로 벌려 확대해서 볼 수 있습니다. 인쇄용 원본은 PDF로 저장하세요.</p>
      <ol className="bro-pages">
        {PAGE_TITLES.map((title, index) => {
          const n = index + 1;
          return (
            <li key={n}>
              <PageImage n={n} title={title} />
              <span className="bro-page-label"><strong>{n} / {PAGE_TITLES.length}</strong> {title}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}

function Summary() {
  return (
    <>
      <section className="bro-section" aria-labelledby="bro-proof-title">
        <p className="bro-kicker">중대재해 발생 시</p>
        <h2 id="bro-proof-title" className="bro-h2">현장통 이용만으로<br />경영책임자의 안전·보건 확보의무 입증 가능</h2>
        <p className="bro-text">사업장 내 철저한 리스크 관리로 중대재해 발생을 <strong>사전에 막는 것</strong>도 중요하지만, 재해가 발생하면 기업이 안전보건 <strong>조치 의무</strong>를 성실히 해왔다는 걸 <strong className="bro-red">'입증'하는 게 핵심</strong>입니다.</p>
        <ul className="bro-proof">
          {PROOF_ITEMS.map(([name, text]) => <li key={name}><strong>{name}</strong><span>{text}</span></li>)}
        </ul>
        <div className="bro-callout">
          <p>3년간 현장통 이용 현장 2곳에서 사망사고 발생</p>
          <p><strong>모두 안전보건 조치의무사항 입증으로, 중대재해처벌법은 무혐의 처리</strong></p>
        </div>
      </section>

      <section className="bro-section" aria-labelledby="bro-pick-title">
        <h2 id="bro-pick-title" className="bro-h2">현장 상황에 맞게 골라 사용하세요</h2>
        <ul className="bro-cards">
          {PICK_FEATURES.map(feature => (
            <li key={feature.name}>
              <h3>{feature.name}{feature.soon && <span className="bro-soon">오픈 예정</span>}</h3>
              <ul>{feature.items.map(item => <li key={item}>{item}</li>)}</ul>
            </li>
          ))}
        </ul>
      </section>

      <section className="bro-section" aria-labelledby="bro-system-title">
        <p className="bro-kicker">본사부터 각 현장 근로자까지</p>
        <h2 id="bro-system-title" className="bro-h2">연결된 시스템</h2>
        <ol className="bro-layers">
          {SYSTEM_LAYERS.map(([name, items]) => <li key={name}><h3>{name}</h3><ul>{items.map(item => <li key={item}>{item}</li>)}</ul></li>)}
        </ol>
        <h3 className="bro-h3">다국어 서비스 <span>외국인 근로자와 현장 소통 가능 · {LANGUAGES.length}개 언어</span></h3>
        <ul className="bro-chips">{LANGUAGES.map(lang => <li key={lang}>{lang}</li>)}</ul>
        <h3 className="bro-h3">본사 모니터링 시스템</h3>
        <ul className="bro-list">
          <li>중대재해예방 법률 검토 (법무법인 이목)</li>
          <li>실시간 본사의 현장 위험성 모니터링 시스템으로 건설근로자의 안전 확보 및 건설사 이익 증대</li>
          <li>현장 · 협력사 데이터 기반 성과평가</li>
        </ul>
      </section>

      <section className="bro-section" aria-labelledby="bro-main-title">
        <h2 id="bro-main-title" className="bro-h2">현장통 주요 기능</h2>
        <ol className="bro-main">
          {MAIN_FEATURES.map(feature => (
            <li key={feature.no}>
              <h3><span className="bro-no">{feature.no}</span>{feature.name}</h3>
              {feature.lead && <p className="bro-lead-text">{feature.lead}</p>}
              {feature.items && <ul className="bro-list">{feature.items.map(item => <li key={item}>{item}</li>)}</ul>}
              {feature.flow && <ol className="bro-flow">{feature.flow.map(step => <li key={step}>{step}</li>)}</ol>}
            </li>
          ))}
        </ol>
      </section>

      <section className="bro-section" aria-labelledby="bro-effect-title">
        <h2 id="bro-effect-title" className="bro-h2">현장통 기대 효과</h2>
        <ul className="bro-effects">
          {EFFECTS.map(([who, items]) => <li key={who}><h3>{who}</h3><ul>{items.map(item => <li key={item}>{item}</li>)}</ul></li>)}
        </ul>
      </section>
    </>
  );
}

export default function Brochure() {
  // #pages 로 열면 원본 페이지 보기로 시작 (안내표·링크에서 바로 연결용)
  const [view, setView] = useState(() => (typeof window !== 'undefined' && window.location.hash === '#pages' ? 'pages' : 'summary'));

  useEffect(() => {
    const previousTitle = document.title;
    document.title = '현장통 브로슈어 | 2026 한국건설·안전박람회';
    window.scrollTo(0, 0);
    track('brochure_open');
    return () => { document.title = previousTitle; };
  }, []);

  const choose = next => {
    setView(next);
    track('brochure_view_change', { view: next });
    const tabs = document.getElementById('bro-tabs');
    if (tabs) tabs.scrollIntoView({ block: 'start' });
  };

  return (
    <div className="bro">
      <header className="bro-header">
        <a href="/" className="bro-brand" aria-label="현장통 홈"><img src={logo} width="32" height="32" alt="" /><span>현장통</span></a>
        <a className="bro-header-link" href="/">홈페이지 <span aria-hidden="true">↗</span></a>
      </header>

      <main>
        <section className="bro-hero">
          <p className="bro-eyebrow">{EXPO}</p>
          <h1>현장 안전관리자들의 동반자<br />쉽고 간편한 안전관리시스템 <em>현장통</em></h1>
          <p className="bro-hero-text">박람회 브로슈어 8페이지를 스마트폰에 맞게 정리했습니다.<br />원본 페이지 그대로 보거나 PDF로 저장할 수 있습니다.</p>
          <div className="bro-hero-actions">
            <PdfLink className="bro-btn bro-btn-primary" location="hero">브로슈어 PDF 저장 <small>(1.9MB)</small> <span aria-hidden="true">↓</span></PdfLink>
            <button type="button" className="bro-btn" onClick={() => choose('pages')}>원본 페이지로 보기</button>
          </div>
        </section>

        <div className="bro-tabs" id="bro-tabs" role="tablist" aria-label="보기 방식">
          <button type="button" role="tab" aria-selected={view === 'summary'} className={view === 'summary' ? 'is-active' : ''} onClick={() => choose('summary')}>핵심 요약</button>
          <button type="button" role="tab" aria-selected={view === 'pages'} className={view === 'pages' ? 'is-active' : ''} onClick={() => choose('pages')}>원본 8페이지</button>
        </div>

        {view === 'pages' ? <Pages /> : <Summary />}

        <section className="bro-section bro-contact" aria-labelledby="bro-contact-title">
          <h2 id="bro-contact-title" className="bro-h2">문의 · 담당자</h2>
          <ul className="bro-contacts">
            {CONTACTS.map(person => (
              <li key={person.name}>
                <strong>{person.name} <span>{person.role}</span></strong>
                <a href={`tel:${person.phone.replace(/-/g, '')}`} onClick={() => track('phone_click', { location: 'brochure_contact' })}>M {person.phone}</a>
                <a href={`mailto:${person.email}`}>E {person.email}</a>
              </li>
            ))}
          </ul>
          <address className="bro-company">
            <strong>㈜통하는사람들</strong> 대표이사 유현석<br />
            서울시 송파구 올림픽로49길 8, 지하 1층 (풍납동)<br />
            <a href="tel:0232722302" onClick={() => track('phone_click', { location: 'brochure_company' })}>T 02-3272-2302</a> · <a href="mailto:admin@hongtong.kr">admin@hongtong.kr</a> · <a href="https://hongtong.kr">hongtong.kr</a>
          </address>
          <div className="bro-hero-actions">
            <PdfLink className="bro-btn bro-btn-primary" location="footer">브로슈어 PDF 저장 <span aria-hidden="true">↓</span></PdfLink>
            <a className="bro-btn" href="/#contact" onClick={() => track('trial_cta_click', { location: 'brochure_footer' })}>무료체험 문의 <span aria-hidden="true">↗</span></a>
          </div>
        </section>
      </main>

      <nav className="bro-bar" aria-label="브로슈어 빠른 동작">
        <a className="bro-bar-phone" href="tel:0232722302" onClick={() => track('phone_click', { location: 'brochure_bar' })}><span>전화 상담</span><strong>02-3272-2302</strong></a>
        <PdfLink className="bro-bar-pdf" location="bar">PDF 저장 <span aria-hidden="true">↓</span></PdfLink>
        <a className="bro-bar-trial" href="/#contact" onClick={() => track('trial_cta_click', { location: 'brochure_bar' })}>무료체험 문의</a>
      </nav>
    </div>
  );
}
